var viewer_rtlignore_default = {
  "gallery_container": "QmRBT",
  "imageTitleContainer": "cBEkt",
  "clickableItem": "_6lK-9",
  "prerender": "ibeSu",
  "expandContainer": "NFkWi",
  "expandIcon": "_9-KIL",
  "itemOverlay": "JT-s9",
  "imageTitle": "pTaTu",
  "pointer": "_7axVu",
  "fadeIn": "miN9c",
  "changing_background": "U8KAV"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
